 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		53: 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		53: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "static/js/" + ({"20":"affiliate-page","21":"algolia-search","22":"algolia-search-local","23":"card-error","24":"cart-drawer","25":"christmas-holiday-gift-cards-page","26":"consumer-checkout-page","27":"consumer-checkout-page-footer-content","28":"create-a-card-carrier","29":"create-a-card-landing","30":"create-a-card-review","31":"designer-gift-cards","32":"diwali-holiday-gift-cards-page","33":"gift-card-app-page","34":"gift-card-balance-check-page","35":"gift-card-occasions","36":"greeting-card-landing-page","37":"handwritten-page","38":"hanukkah-holiday-gift-cards-page","39":"home-page","40":"kwanzaa-holiday-gift-cards-page","41":"legit-page","43":"mastercard-pla-landing-page","44":"newsletter-signup-page","45":"open-loop-activate-check-balance","46":"open-loop-virtual-exchange","47":"order-details","48":"order-status","49":"pla-landing-page-container","50":"redeem-gift","51":"redeem-gyp-gift","52":"reviews-page","54":"smb-apply","55":"smb-cobrand-cards","56":"smb-order-details","57":"smb-order-details-pdf-invoice","58":"smb-order-flow","59":"smb-order-flow-cancelled","60":"smb-order-flow-confirmation","61":"smb-order-flow-customize-product","62":"smb-order-flow-footer-content","63":"smb-order-flow-landing","64":"smb-order-flow-login","65":"smb-order-flow-merchant","66":"smb-order-flow-merchant-directory","67":"smb-order-flow-place-order","68":"smb-order-flow-product-details","69":"smb-order-flow-registration","70":"smb-resubmission-portal","71":"store-review-list-portal","72":"update-failed-email-recipient","73":"update-payment-method","74":"visa-pla-landing-page"}[chunkId]||chunkId) + "." + {"0":"17a8598a","1":"3f8e83a2","2":"23890b00","3":"937d14c8","4":"282c439d","5":"948ee2c0","6":"0ac1f40a","7":"6d2c6536","8":"b30c43d0","9":"66a9fd76","10":"79865b2a","11":"8663fb0e","12":"ef61145d","13":"676c421c","14":"bb28e7d7","15":"5f0259ef","16":"84fcb7a9","17":"fb2536bc","18":"3fb788e5","19":"7820b258","20":"6afb3ca2","21":"01c4106a","22":"be8b2967","23":"5648741d","24":"7f540e1b","25":"2550886e","26":"7913a28e","27":"969aa030","28":"3de5731f","29":"19f13340","30":"ee22f751","31":"5e59eff2","32":"6e5a0acf","33":"1df98425","34":"b384655f","35":"66a6a482","36":"5163fc2d","37":"3485410d","38":"9bcbd4ea","39":"77d29e0a","40":"b1383798","41":"2b3ba041","43":"2f20ca58","44":"1c5a7a85","45":"239b36cf","46":"b8a6bab5","47":"117f029d","48":"9544ecad","49":"86281d8c","50":"da1f7960","51":"aac39730","52":"5fcbd280","54":"0eedca75","55":"9b3f6bd9","56":"18ec352e","57":"2ea0fc4e","58":"db81b66e","59":"75f10e1b","60":"5e56b248","61":"079bd592","62":"d51d4e8f","63":"26485a24","64":"14bfd3d0","65":"c9d9a90b","66":"443f5fdf","67":"ea00fad3","68":"adbba964","69":"185f6edd","70":"44838fc2","71":"6e4e9d51","72":"007e9e03","73":"b5ed3527","74":"e46915d3","76":"bf7194b5","77":"6f2cf827","78":"3b2f72a0","79":"286880e4","80":"eaf048d8","81":"9d6bd911","82":"c8e0d1b1","83":"c25942d8","84":"330851c7","85":"11b6e851","86":"ba54af51","87":"a408586d","88":"b4891377"}[chunkId] + ".chunk.js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"29":1,"48":1,"61":1,"80":1,"83":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "static/css/" + ({"20":"affiliate-page","21":"algolia-search","22":"algolia-search-local","23":"card-error","24":"cart-drawer","25":"christmas-holiday-gift-cards-page","26":"consumer-checkout-page","27":"consumer-checkout-page-footer-content","28":"create-a-card-carrier","29":"create-a-card-landing","30":"create-a-card-review","31":"designer-gift-cards","32":"diwali-holiday-gift-cards-page","33":"gift-card-app-page","34":"gift-card-balance-check-page","35":"gift-card-occasions","36":"greeting-card-landing-page","37":"handwritten-page","38":"hanukkah-holiday-gift-cards-page","39":"home-page","40":"kwanzaa-holiday-gift-cards-page","41":"legit-page","43":"mastercard-pla-landing-page","44":"newsletter-signup-page","45":"open-loop-activate-check-balance","46":"open-loop-virtual-exchange","47":"order-details","48":"order-status","49":"pla-landing-page-container","50":"redeem-gift","51":"redeem-gyp-gift","52":"reviews-page","54":"smb-apply","55":"smb-cobrand-cards","56":"smb-order-details","57":"smb-order-details-pdf-invoice","58":"smb-order-flow","59":"smb-order-flow-cancelled","60":"smb-order-flow-confirmation","61":"smb-order-flow-customize-product","62":"smb-order-flow-footer-content","63":"smb-order-flow-landing","64":"smb-order-flow-login","65":"smb-order-flow-merchant","66":"smb-order-flow-merchant-directory","67":"smb-order-flow-place-order","68":"smb-order-flow-product-details","69":"smb-order-flow-registration","70":"smb-resubmission-portal","71":"store-review-list-portal","72":"update-failed-email-recipient","73":"update-payment-method","74":"visa-pla-landing-page"}[chunkId]||chunkId) + "." + {"0":"31d6cfe0","1":"31d6cfe0","2":"31d6cfe0","3":"31d6cfe0","4":"31d6cfe0","5":"31d6cfe0","6":"31d6cfe0","7":"31d6cfe0","8":"31d6cfe0","9":"31d6cfe0","10":"31d6cfe0","11":"31d6cfe0","12":"31d6cfe0","13":"31d6cfe0","14":"31d6cfe0","15":"31d6cfe0","16":"31d6cfe0","17":"31d6cfe0","18":"31d6cfe0","19":"31d6cfe0","20":"31d6cfe0","21":"31d6cfe0","22":"31d6cfe0","23":"31d6cfe0","24":"31d6cfe0","25":"31d6cfe0","26":"31d6cfe0","27":"31d6cfe0","28":"31d6cfe0","29":"7176885d","30":"31d6cfe0","31":"31d6cfe0","32":"31d6cfe0","33":"31d6cfe0","34":"31d6cfe0","35":"31d6cfe0","36":"31d6cfe0","37":"31d6cfe0","38":"31d6cfe0","39":"31d6cfe0","40":"31d6cfe0","41":"31d6cfe0","43":"31d6cfe0","44":"31d6cfe0","45":"31d6cfe0","46":"31d6cfe0","47":"31d6cfe0","48":"21f59128","49":"31d6cfe0","50":"31d6cfe0","51":"31d6cfe0","52":"31d6cfe0","54":"31d6cfe0","55":"31d6cfe0","56":"31d6cfe0","57":"31d6cfe0","58":"31d6cfe0","59":"31d6cfe0","60":"31d6cfe0","61":"c8c378cd","62":"31d6cfe0","63":"31d6cfe0","64":"31d6cfe0","65":"31d6cfe0","66":"31d6cfe0","67":"31d6cfe0","68":"31d6cfe0","69":"31d6cfe0","70":"31d6cfe0","71":"31d6cfe0","72":"31d6cfe0","73":"31d6cfe0","74":"31d6cfe0","76":"31d6cfe0","77":"31d6cfe0","78":"31d6cfe0","79":"31d6cfe0","80":"1934b2f3","81":"31d6cfe0","82":"31d6cfe0","83":"c8c378cd","84":"31d6cfe0","85":"31d6cfe0","86":"31d6cfe0","87":"31d6cfe0","88":"31d6cfe0"}[chunkId] + ".chunk.css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://sitecdn.giftcardgranny.com/20032/react/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = this["webpackJsonpgift-card-granny-react"] = this["webpackJsonpgift-card-granny-react"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
